<template>
	<div class="change-password-wrapper">
		<div class="form-card">
			<h3 class="form-title">修改密码</h3>
			<el-form ref="changePassWordForm" :model="changePassWordForm" :rules="changePassWordRules" label-width="100px" class="modern-form" label-position="left">
				<el-form-item label="旧密码" prop="oldPassword">
					<el-input v-model="changePassWordForm.oldPassword" type="password" placeholder="请输入旧密码" class="form-input" show-password></el-input>
				</el-form-item>
				<el-form-item label="新密码" prop="newPassword">
					<el-input v-model="changePassWordForm.newPassword" type="password" placeholder="请输入新密码" class="form-input" show-password></el-input>
				</el-form-item>
				<el-form-item label="确认密码" prop="surePassword">
					<el-input v-model="changePassWordForm.surePassword" type="password" placeholder="请再次输入新密码" class="form-input" show-password></el-input>
				</el-form-item>
				<el-form-item class="form-actions">
					<el-button type="primary" @click="onSubmit('changePassWordForm')" class="submit-btn">提交</el-button>
					<el-button class="cancel-btn">取消</el-button>
				</el-form-item>
			</el-form>
		</div>
	</div>
</template>

<script>
	import {changePassword} from "@/api/index.js"
	export default {
		props:["userId"],
		data() {
			var checkSurePassWord = (rule, value, callback) => {
				if (!value) {
					return callback(new Error('请再次输入新密码'))
				}
				setTimeout(() => {
					if (value === this.changePassWordForm.newPassword) {
						callback()
					} else {
						callback(new Error('两次输入密码需要一致'))
					}
				}, 100)
			};
			return {
				changePassWordForm: {
					oldPassword: "",
					newPassword: "",
					surePassword: ""
				},
				changePassWordRules: {
					oldPassword: [{
							required: true,
							message: '请输入旧密码',
							trigger: 'blur'
						},
						{
							min: 4,
							message: '长度大于4个字符',
							trigger: 'blur'
						}
					],
					newPassword: [{
							required: true,
							message: '请输入新密码',
							trigger: 'blur'
						},
						{
							min: 4,
							message: '长度大于4个字符',
							trigger: 'blur'
						}
					],
					surePassword: [{
							required: true,
							message: '请再次输入新密码',
							trigger: 'blur'
						},
						{
							min: 4,
							message: '长度大于4个字符',
							trigger: 'blur'
						}, {
							validator: checkSurePassWord,
							trigger: 'blur'
						}
					],
				}
			}
		},
		methods: {
			onSubmit(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						// console.log(this.changePassWordForm)
						// let loginAccount = localStorage.getItem("username")
						let param = {
							id:this.userId,
							loginAccount:localStorage.getItem("username"),
							oldPassword:this.changePassWordForm.oldPassword,
							newPassword:this.changePassWordForm.newPassword
						}
						changePassword(param).then(res => {
							// console.log(res)
							if(res.code == "0000"){
								this.$router.push({path:"/"})
							}
						})
						// console.log(param)
						// alert('submit!');
					} else {
						// console.log('error submit!!');
						return false;
					}
				});
			}
		}
	}
</script>

<style lang="scss" scoped>
.change-password-wrapper {
	padding: 0 30px;
}

.form-card {
	background: #FFFFFF;
	border-radius: 8px;
	padding: 30px;
}

.form-title {
	font-size: 18px;
	color: #303133;
	margin: 0 0 25px 0;
	font-weight: 500;
	padding-left: 12px;
	border-left: 3px solid #409EFF;
}

.modern-form {
	max-width: 600px;
}

.modern-form ::v-deep .el-form-item {
	margin-bottom: 24px;
}

.modern-form ::v-deep .el-form-item__label {
	font-size: 14px;
	color: #606266;
	font-weight: 400;
}

.form-input {
	width: 400px;
}

.form-input ::v-deep .el-input__inner {
	height: 40px;
	line-height: 40px;
	border-radius: 6px;
	border: 1px solid #DCDFE6;
	transition: all 0.3s ease;

	&:hover {
		border-color: #C0C4CC;
	}

	&:focus {
		border-color: #409EFF;
		box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
	}
}

.form-input ::v-deep .el-input__inner::placeholder {
	color: #C0C4CC;
	font-size: 14px;
}

.form-actions {
	margin-top: 30px;
}

.submit-btn {
	width: 120px;
	height: 40px;
	background: linear-gradient(135deg, #67B3FF 0%, #409EFF 100%);
	border: none;
	border-radius: 6px;
	font-size: 15px;
	transition: all 0.3s ease;

	&:hover {
		box-shadow: 0 4px 12px rgba(64, 158, 255, 0.4);
		transform: translateY(-2px);
	}

	&:active {
		transform: translateY(0);
	}
}

.cancel-btn {
	width: 120px;
	height: 40px;
	border-radius: 6px;
	font-size: 15px;
	color: #606266;
	border: 1px solid #DCDFE6;
	background: #FFFFFF;
	transition: all 0.3s ease;

	&:hover {
		color: #409EFF;
		border-color: #C6E2FF;
		background: #ECF5FF;
	}
}
</style>
